import { inject, type InjectionKey } from 'vue'
import type { OperacoesCatalogoMotivoPadrao } from '../catalogo-motivo-padrao.tipos'
export const CHAVE_OPERACOES_CATALOGO_MOTIVO_PADRAO: InjectionKey<OperacoesCatalogoMotivoPadrao> = Symbol('operacoes-catalogo-motivo-padrao')
export const usarOperacoesCatalogoMotivoPadrao = (): OperacoesCatalogoMotivoPadrao => {
  const operacoes = inject(CHAVE_OPERACOES_CATALOGO_MOTIVO_PADRAO)
  if (!operacoes) throw new Error('Catalogo de motivo padrao nao foi instalado')
  return operacoes
}
